import { ShrimpCategoryRecord } from './types'

export const SHRIMP_CATEGORIES: ShrimpCategoryRecord[] = [
  {
    id: 1,
    name: 'กุ้งดี',
    subCategories: [
      {
        id: 1,
        name: 'เบอร์ 0',
        amount: '',
        price: '',
      },
      {
        id: 2,
        name: 'เบอร์ 1',
        amount: '',
        price: '',
      },
      {
        id: 3,
        name: 'เบอร์ 2',
        amount: '',
        price: '',
      },
      {
        id: 4,
        name: 'เบอร์ 3',
        amount: '',
        price: '',
      },
    ],
  },
  {
    id: 2,
    name: 'กุ้งนิ่ม',
    subCategories: [
      {
        id: 1,
        name: '-',
        amount: '',
        price: '',
      },
    ],
  },
  {
    id: 3,
    name: 'กุ้งขาด',
    subCategories: [
      {
        id: 1,
        name: '-',
        amount: '',
        price: '',
      },
    ],
  },
  {
    id: 4,
    name: 'กุ้งผอม',
    subCategories: [
      {
        id: 1,
        name: '-',
        amount: '',
        price: '',
      },
    ],
  },
  {
    id: 5,
    name: 'กุ้งเสีย',
    subCategories: [
      {
        id: 1,
        name: '-',
        amount: '',
        price: '',
      },
    ],
  },
]

export const FISH_CATEGORIES: ShrimpCategoryRecord[] = [
  {
    id: 1,
    name: 'ปลาใหญ่',
    subCategories: [
      {
        id: 1,
        name: '-',
        amount: '',
        price: '',
      },
    ],
  },
  {
    id: 2,
    name: 'ปลาเค็ม',
    subCategories: [
      {
        id: 1,
        name: '-',
        amount: '',
        price: '',
      },
    ],
  },
  {
    id: 3,
    name: 'ปลารอง',
    subCategories: [
      {
        id: 1,
        name: '-',
        amount: '',
        price: '',
      },
    ],
  },
  {
    id: 4,
    name: 'ปลาลูก',
    subCategories: [
      {
        id: 1,
        name: '-',
        amount: '',
        price: '',
      },
    ],
  },
]
